<template>
  <div class="tw:text-sm tw:text-gray-800 tw:bg-red-200 tw:rounded-lg tw:px-5 tw:py-4">
    <p
      class="notification tw:inline tw:mr-1"
      v-html="type === 'RATE_CONNECT' ? $t('rc_fop_expired_info') : $t('plus_fop_expired_info')"
    />
    <i18n-t keypath="fop_hotelier_support" tag="p" class="expired-note tw:inline">
      <template #HotelierSupport>
        <button
          @click="handleRedirection"
          class="tw:text-gray-800 tw:hover:text-blue-800 tw:cursor-pointer tw:underline"
        >
          {{ $t('hotelier_support_team') }}
        </button>
      </template>
    </i18n-t>
  </div>
</template>
<script setup>
import { computed } from 'vue'

import { selectedAccommodationId } from '@/layouts/queries'
import { getContactUrl } from '@/utils/Utility.ts'

import appAnalytics from '@/utils/tracking'
import { useSessionValues } from '@/composables/useSessionValues'

const props = defineProps({
  type: String,
  defaultPaymentMethod: Object,
})

const { language, userId } = useSessionValues()
const contactUrl = computed(() => getContactUrl(language.value, userId.value, selectedAccommodationId.value, true))
const handleRedirection = () => {
  appAnalytics.track(appAnalytics.events.RC_RESUME_CAMPAIGN_HOTELIER_SUPPORT_CLICKED, {
    accommodationId: selectedAccommodationId.value,
    paymentMethod: props.defaultPaymentMethod?.type,
    isExpired: true,
    expirationDate: `${props.defaultPaymentMethod?.expirationMonth}/${props.defaultPaymentMethod?.expirationYear}`,
  })
  window.open(contactUrl.value, '_blank', 'noopener,noreferrer')
}
</script>
<style scoped>
.notification :deep(span) {
  font-weight: bold;
}
</style>
